import React, { useState, useEffect } from "react";
import NavHeader from "../Common/NavHeader";
import RestaurantTable from "./RestaurantTable";
import BreadCrumb from "../Common/BreadCrumb";
import Paginator from "../Common/Paginator";
import {
  startJob,
  stopJob,
  getJobStatus,
  handleAutoSyncToggle,
  useGetAllRestaurants,
  toggleSFTP
} from "./api";
import useAppStore from "../../store/global";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

export default function Home() {
  // const [restaurants, setRestaurants] = useState([]);
  const [scrappers_type, setScrappers_type] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const {
    pageNum,
    setPageNum,
    totalPages,
    setTotalPages,
    loading,
    setLoading,
    pageSize
  } = useAppStore();
  const [toggleLoading, setToggleLoading] = useState(false);
  const [togglingId, setTogglingId] = useState(null);
  const { data, isLoading } = useGetAllRestaurants(
    pageNum,
    pageSize,
    scrappers_type,
    searchTerm
  );

  useEffect(() => {
    setTotalPages(data?.totalPages);
    setLoading(isLoading);
  }, [data]);
  // const fetchRestaurants = () => {



  const handleStartJob = (job_id) => {
    setToggleLoading(true);
    startJob(job_id)
      .then((data) => {
        setToggleLoading(false);
        setTogglingId(null);
        // fetchRestaurants();
        toast.success("Started Successfully");
      })
      .catch((err) => {
        setToggleLoading(false);
        setTogglingId(null);
        toast.error("Something went wrong");
      });
  };

  const handleStopJob = (job_id) => {
    setToggleLoading(true);
    stopJob(job_id)
      .then((data) => {
        setToggleLoading(false);
        setTogglingId(null);
        // fetchRestaurants();
        toast.success("Stopped Successfully");
      })
      .catch((err) => {
        setToggleLoading(false);
        setTogglingId(null);
        toast.error("Something went wrong");
      });
  };

  const checkJobStatus = (pos_id) => {
    setToggleLoading(true);
    getJobStatus(pos_id)
      .then((data) => {
        setTogglingId(null);
        setToggleLoading(false);
        if (data.scrapped === true) {
          toast.success("Data has been scrapped successfully");
        } else {
          toast.warning("Data has not been scrapped yet");
        }
      })
      .catch((err) => {
        setTogglingId(null);
        setToggleLoading(false);
        toast.error("Something went wrong");
      });
  };

  const autoSyncToggleHandler = (restaurant_id, auto_sync) => {
    setToggleLoading(true);
    handleAutoSyncToggle(restaurant_id, auto_sync)
      .then((data) => {
        setToggleLoading(false);
        // fetchRestaurants();
        toast.success(data.message);
      })
      .catch((err) => {
        setToggleLoading(false);
        toast.error("Something went wrong");
      });
  };

  const SFTPToggleHandler = (job_id, sftp_enabled,restaurant_id) => {
    toggleSFTP(job_id, sftp_enabled)
      .then((da) => {
        // fetchRestaurants();
        toast.success(da?.message);
       window.location.reload()
        
      })
      .catch((err) => {
        // console.log(err)
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <NavHeader view="home" />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb
          text="Home > Restaurants"
          showHomeFilter={true}
          setScrappers_type={setScrappers_type}
          scrappers_type={scrappers_type}
          setSearchTerm={setSearchTerm}
        />
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <RestaurantTable
              restaurants={data?.restaurants}
              handleStartJob={handleStartJob}
              handleStopJob={handleStopJob}
              toggleLoading={toggleLoading}
              togglingId={togglingId}
              setTogglingId={setTogglingId}
              checkJobStatus={checkJobStatus}
              autoSyncToggleHandler={autoSyncToggleHandler}
              SFTPToggleHandler={SFTPToggleHandler}
            />
            <Paginator
              pageNum={pageNum}
              setPageNum={setPageNum}
              totalPages={totalPages}
            />
          </>
        )}
      </div>
      <ToastContainer />
    </>
  );
}
